import { render, staticRenderFns } from "./startQuiz.vue?vue&type=template&id=03c5ccb8&scoped=true"
import script from "./startQuiz.vue?vue&type=script&lang=js"
export * from "./startQuiz.vue?vue&type=script&lang=js"
import style0 from "./startQuiz.vue?vue&type=style&index=0&id=03c5ccb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c5ccb8",
  null
  
)

export default component.exports